// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Atom_Box from "../../atom/Atom_Box.bs.js";
import * as Atom_Cta from "../../atom/Atom_Cta.bs.js";
import * as Atom_Cell from "../../atom/Atom_Cell.bs.js";
import * as UseOnBlur from "../../../hook/UseOnBlur.bs.js";
import * as UseToggle from "../../../hook/UseToggle.bs.js";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as Atom_Column from "../../atom/Atom_Column.bs.js";
import * as Type_Header from "../../../type/Type_Header.bs.js";
import * as UseClickOutside from "../../../hook/UseClickOutside.bs.js";
import * as Organism_Menu_Css from "./Organism_Menu_Css.bs.js";
import * as Particle_Screen_Ds from "../../particle/Particle_Screen_Ds.bs.js";
import * as Particle_Accessibility from "../../particle/Particle_Accessibility.bs.js";

var displayBlocksProperty = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "block");

function Organism_Menu_Item_With_Childs(Props) {
  var id = Props.id;
  var label = Props.label;
  var subLinks = Props.subLinks;
  var ariaLabel = Props.ariaLabel;
  var highlightOpt = Props.highlight;
  var view = Props.view;
  var highlight = highlightOpt !== undefined ? highlightOpt : false;
  var ctaChildStyle = view.ctaChildStyle;
  var ref = React.useRef(null);
  var match = UseToggle.make(undefined, undefined, undefined, undefined);
  var close = match.close;
  var state = match.state;
  var style = Curry._2(view.ctaWithChildsStyle, state, highlight);
  var accessibility = Particle_Accessibility.make(undefined, undefined, undefined, undefined, undefined, match.stateBoolean, undefined, ariaLabel, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  var display = state ? Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "none") : displayBlocksProperty;
  UseClickOutside.make(ref, close);
  UseOnBlur.make(ref, close);
  return React.createElement(Atom_Box.make, {
              children: null,
              display: displayBlocksProperty,
              id: id,
              kind: /* ItemList */4,
              ref_: ref,
              key: id
            }, React.createElement(Atom_Cta.Button.make, {
                  accessibility: accessibility,
                  label: label,
                  onClick: match.toggle,
                  style: style
                }), React.createElement(Atom_Column.make, {
                  background: view.background,
                  children: Belt_Array.map(subLinks, (function (param) {
                          var id = param.id;
                          return React.createElement(Atom_Cell.make, {
                                      kind: /* ItemList */4,
                                      height: Type_Header.Constants.heightStyle,
                                      id: id,
                                      children: React.createElement(Atom_Cta.Link.make, {
                                            href: param.href,
                                            label: param.label,
                                            style: Curry._1(ctaChildStyle, param.highlight)
                                          }),
                                      key: id
                                    });
                        })),
                  display: display,
                  kind: /* List */5,
                  rules: Organism_Menu_Css.rulesChildsItems
                }));
}

var make = Organism_Menu_Item_With_Childs;

export {
  displayBlocksProperty ,
  make ,
}
/* displayBlocksProperty Not a pure module */
